const options = {
  5: "bg-fuchsia-900/5",
  10: "bg-fuchsia-900/10",
  25: "bg-fuchsia-900/25",
  50: "bg-fuchsia-900/50",
  75: "bg-fuchsia-900/75",
  90: "bg-fuchsia-900/90",
  100: "bg-fuchsia-900",
};

const from = {
  5: "from-fuchsia-900/5",
  10: "from-fuchsia-900/10",
  25: "from-fuchsia-900/25",
  50: "from-fuchsia-900/50",
  75: "from-fuchsia-900/75",
  90: "from-fuchsia-900/90",
  100: "from-fuchsia-900",
};

export default function getBackgroundFuchsia900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
